import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Source Onboarding', value: 'source_onboarding_name' },
  { text: 'Nama Aggregator', value: 'name' },
  { text: 'Alamat Lengkap', value: 'address' },
  { text: 'No. Handphone', value: 'mobile_phone' },
  { text: 'Branch Code BC/KO', value: 'bcko'},
  { text: 'Merchant Category Segment', value: 'cmer'},
  { text: 'Tanggal Active', value: 'active_date'},
  { text: 'Tanggal Inactive', value: 'inactive_date'},
  { text: 'Status', value: 'status'},
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
]);

export const search = {
  source_onboarding: '',
  name: '',
  inactive_date: [],
  mobile_phone: '',
  address: '',
  bcko: '',
  cmer: '',
  status: '',
  active_date: [],
};
